import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/websites/index.vue'

export default class extends Controller {
  static values = {
    businessId: String,
    businessName: String
  }

  connect() {
    this.vue = createApp(App, {
      businessId: this.businessIdValue,
      businessName: this.businessNameValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
